import { CaretRight, House } from '@phosphor-icons/react';

// Read-only breadcrumb trail for NAS browsing. No DMS folder coupling.
export default function NasBreadcrumbs({ rootName, trail, onRoot, onCrumb }) {
  return (
    <nav className="flex items-center gap-1 flex-wrap text-sm" data-testid="nas-breadcrumbs">
      <button type="button" onClick={onRoot} data-testid="nas-crumb-root"
        className="inline-flex items-center gap-1 rounded px-1.5 min-h-[32px] text-zinc-700 hover:bg-zinc-100">
        <House size={14} /> {rootName || 'NAS'}
      </button>
      {(trail || []).map((c, i) => (
        <span key={c.node_id} className="inline-flex items-center gap-1">
          <CaretRight size={11} className="text-zinc-300" />
          <button type="button" onClick={() => onCrumb(i)}
            data-testid={`nas-crumb-${i}`}
            className="rounded px-1.5 min-h-[32px] text-zinc-700 hover:bg-zinc-100 truncate max-w-[220px]">
            {c.name}
          </button>
        </span>
      ))}
    </nav>
  );
}
